import topSongsQuery from "../core/graphql/queries/findTop5Artist"
import { useQuery } from '@apollo/client';
import { makeStyles, Theme } from '@material-ui/core';
import { useHistory } from "react-router-dom";
import Avatar from "../pictures/dummyAvatar.svg"

export const TopSong = ({ type }: { type: string }) => {
    const useStyles = makeStyles<Theme>(() => ({
        imageContainer: {
            width: '100px',
            height: '100px',
            borderRadius: '5px',
        },
        list: {
            display: 'flex',
            gap: "0.5rem",
        },
        text: {
            fontSize: '14px',
            wordBreak: "break-word"
        }
    }));

    const history = useHistory()
    const classes = useStyles()

    const effectiveType = type === 'today' ? 'week' : type;

    const { data } = useQuery<any>(topSongsQuery, {
        variables: { type: effectiveType },
        errorPolicy: 'all'
    })

    const songs = (data?.findTopSongAlbumArtist || []).slice(0, 5);

    return (
        <div className={classes.list}>
            {songs.map((song: any) => (
                <div
                    key={song._id}
                    style={{ width: '120px', textAlign: 'center', cursor: 'pointer' }}
                    onClick={() => song?._id && history.push(`/song/${song._id}`)}
                >
                    <img
                        src={song?.image ? song.image : Avatar}
                        alt=""
                        className={classes.imageContainer}
                    />
                    <h3 className={classes.text}>
                        {song?.name}
                    </h3>
                </div>
            ))}
        </div>
    )
}
